import React from 'react';

import HotelIcon from '../../stories/Icons/HotelIcon';
import AreaIcon from '../../stories/Icons/AreaIcon';
import LocationIcon from '../../stories/Icons/LocationIcon';
import FlightIcon from '../../stories/Icons/FlightIcon';

const AutosuggestIconSelector = ({
  name,
  ...styleProps
}: {
  name: 'area' | 'city' | 'landmark' | 'hotel' | 'airport';
}) => {
  switch (name) {
    case 'area':
    case 'city':
      return <AreaIcon {...styleProps} />;
    case 'landmark':
      return <LocationIcon {...styleProps} />;
    case 'hotel':
      return <HotelIcon {...styleProps} />;
    case 'airport':
      return <FlightIcon {...styleProps} />;
    default:
      return <AreaIcon {...styleProps} />;
  }
};

export default AutosuggestIconSelector;
